

















import { Component, Vue, Prop  } from 'vue-property-decorator'

/**
 * 图片和视屏缩略图展示组件
 */
@Component

export default class VideoShow extends Vue {

  @Prop({
    required: false,
    default: []
  })
  fileList: Object
  @Prop({
    type: Function,
    required: false,
  })
  preview: any


  public privewImg(path?: any) {
    this.preview(path);
  }
  public created() {

  }
}
